import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import template from './features.vue';
import apiService from '@/services/api.service';
import { Company, Permission } from '@/definitions';
import { Action } from '@/store';
import { Tab } from '..';

@Component({
  mixins: [template],
})
export default class SettingsFeatures extends Vue {
  @Prop() model!: { permissions: Permission[] };
  @Prop() tab!: Tab;

  @Watch("model", { deep: true })
  permissionsChange() {
    this.$emit("applyChange", this.tab, this.model);
  }

  get company(): Company {
    return this.$Store.state.company.company;
  }

  getPermissionBitmask() {
    return this.model.permissions.filter(p => p.isEnabled).reduce((a, b) => a += b.value, 0);
  }

  async saveChanges() {
    try {
      await apiService.saveCompanyFeatures(this.company._id, { permission: this.getPermissionBitmask() });
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_success', type: 'success' });
      this.$emit("changesSaved", this.tab);
    } catch (e) {
      this.$Store.dispatch(Action.SHOW_ALERT, { text: 'alerts.settings.save_error', type: 'danger' });
    }
  }
}